var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5986 18.25L19.5986 22V5C19.5986 3.34315 18.2555 2 16.5986 2H8.59863C6.94178 2 5.59863 3.34315 5.59863 5V22L12.5986 18.25ZM7.59863 18.6597L12.5986 15.9811L17.5986 18.6597V5C17.5986 4.44772 17.1509 4 16.5986 4H8.59863C8.04635 4 7.59863 4.44772 7.59863 5V18.6597Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutlined);
export default __webpack_public_path__ + "static/media/BookmarkOutlined.22ae975b7abd283ca8ae5f66573071ee.svg";
export { ForwardRef as ReactComponent };